module.exports = __webpack_public_path__ + "static/media/personal-technology.54ed9188.svg";